import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { WidgetModel, InformationModel } from '../../../../core/models/widget.model';
import { HomeService } from 'src/app/home/service/home.service';
import {GoogleTagManagerService} from "../../../../core/analytics/google-tag-manager.service";

@Component({
  selector: 'app-facs-temp',
  templateUrl: './facs-temp.component.html',
  styleUrls: ['./facs-temp.component.scss']
})
export class FacsTempComponent implements OnInit, OnDestroy {

  @Input() public dragged: boolean;
  @Input() public data: WidgetModel;
  @Input() public info: InformationModel[];
  @Input() public scrolling: boolean;

  public timer: any;
  pIdx: number[] = [0, 1, 2];

  constructor(
    private homeSvc: HomeService,
    private router: Router,
    private readonly googleTagManagerService: GoogleTagManagerService) { }

  ngOnInit() {
    this.homeSvc.fetchWidgetData(this.data.id);
    this.timer = window.setInterval(() => {
      this.homeSvc.fetchWidgetData(this.data.id);
    }, this.data.update_timer);
  }

  ngOnDestroy() {
    window.clearInterval(this.timer);
  }

  headerAction() {
    if (this.scrolling) {
      return;
    }

    this.googleTagManagerService.pushTag({
      event: 'event',
      eventCategory: 'crm:home',
      eventAction: 'clique:widgets:temperatura-facs'
    });

    this.router.navigate([`${this.data.action.url}`]);
  }

  iconAction(idx: number) {
    if (this.scrolling) {
      return;
    }

    const temperature = this.info[idx].action.url;

    this.googleTagManagerService.pushTag({
      event: 'event',
      eventCategory: 'crm:home',
      eventAction: 'clique:widgets:temperatura-facs',
      eventLabel: temperature.toLowerCase()
    });

    this.router.navigate([`/facs`], { queryParams: { temperatura: temperature }});
  }

  indexCheck(): void {
    this.info.forEach((inf, idx) => {
      if (inf.type === 'hot') { this.pIdx[0] = idx; }
      if (inf.type === 'warm') { this.pIdx[1] = idx; }
      if (inf.type === 'cold') { this.pIdx[2] = idx; }
    });
  }

}
